import React from 'react';

export interface PlaceholderImageProps {
	/** Whether or not to display a spinner in the center of the placeholder. */
	showSpinner: boolean;
}

function PlaceholderImage({ showSpinner }: PlaceholderImageProps) {
	return (
		<div className="hawk-results__item-placeholder">
			{showSpinner && <div className="hawk-placeholder__image">Loading...</div>}
		</div>
	);
}

export default PlaceholderImage;
